import React from 'react';
import {capitalize} from "../../../../../../Utils";

const Head = ({ params }) => {
    let th = params.map(param => <th key={param}>{capitalize(param)}</th>);

    return (
        <thead>
            <tr>
                {th}
            </tr>
        </thead>
    )
};

export default Head;



// WEBPACK FOOTER //
// ./src/scenes/History/components/Table/components/Head/index.js